var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ac147303ad"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.515625 32.8125 L 369.265625 32.8125 L 369.265625 342.5625 L 5.515625 342.5625 Z M 5.515625 32.8125 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ac147303ad)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D1D1",
    d: "M 151.097656 342.183594 L 151.097656 232.996094 L 223.890625 232.996094 L 223.890625 342.183594 L 314.882812 342.183594 L 314.882812 196.597656 L 369.476562 196.597656 L 187.496094 32.816406 L 5.515625 196.597656 L 60.109375 196.597656 L 60.109375 342.183594 Z M 151.097656 342.183594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.e4c9a7c7f8ab4765a62febf680224e23.svg";
export { ForwardRef as ReactComponent };